import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { rfpAnalysisLogsAsync } from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  rfpLogsLoader: false,
  rfpLogsError: '',
  rfpLogs: [],
}

export const rfpLogsSlice = createSlice({
  name: 'rfpAnalysisLogs',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(rfpAnalysisLogsAsync.pending), (state) => {
      state.rfpLogsLoader = true
    })
    builder.addMatcher(isAnyOf(rfpAnalysisLogsAsync.fulfilled), (state, action) => {
      state.rfpLogsLoader = false
      state.rfpLogs = action.payload
      state.rfpLogsError = ''
    })
    builder.addMatcher(isAnyOf(rfpAnalysisLogsAsync.rejected), (state, action) => {
      state.rfpLogsLoader = false
      state.rfpLogsError = action.payload
    })
  },
  reducers: {
    emptyRFPLogsSlice: (state) => {
      state.rfpLogsLoader = false
      state.rfpLogsError = ''
      state.rfpLogs = []
    },
  },
})

export const { emptyRFPLogsSlice } = rfpLogsSlice.actions;

export default rfpLogsSlice.reducer
